/**
 * Recorte dos módulos de validadores pelo filtro da tela (veículo).
 *
 * Com `apenasDaLista`, o módulo mostra só linhas dos equipamentos recebidos em `equipamentos`
 * — as APIs, sem equipamento escolhido, devolvem a frota inteira. Com um único leitor na lista
 * ele já vem escolhido, e a consulta vai direto para ele.
 *
 * Espera no componente: prop `equipamentos` e o dado `idEquipamento`.
 */
export default {
  props: {
    apenasDaLista: { type: Boolean, default: false },
  },
  computed: {
    idsDaLista() {
      return new Set((this.equipamentos || []).map((e) => e.id_equipamento));
    },
  },
  created() {
    if (this.apenasDaLista && (this.equipamentos || []).length === 1) {
      this.idEquipamento = this.equipamentos[0].id_equipamento;
    }
  },
  methods: {
    recortaDaLista(linhas) {
      if (!this.apenasDaLista) return linhas;
      return (linhas || []).filter((l) => this.idsDaLista.has(l.id_equipamento));
    },
  },
};
